<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>


export default {
  data() {
    return {

    };
  },
  created(){

  },

};

</script>
